module.exports = __webpack_public_path__ + "static/media/List.b5c6888b.svg";